import { Record } from 'immutable';
export default Record({
  id: null,
  info: null,
  setupTime: null,
  confirmedTime: null
}, 'SecurityPhoneNumber');